import { cn } from "@/lib/utils";

export function CardSelector({
  cards,
  selected,
  onSelect,
}: {
  cards: string[];
  selected: string | undefined;
  onSelect: (card: string) => void;
}) {
  return (
    <div className="border-t border-border/50 bg-card/50 px-4 py-4 backdrop-blur">
      <p className="mb-3 text-center text-sm text-muted-foreground" id="choose-card">
        Choose your card 👇
      </p>
      <div
        className="flex flex-wrap justify-center gap-2"
        role="group"
        aria-labelledby="choose-card"
      >
        {cards.map((card) => (
          <button
            key={card}
            type="button"
            aria-pressed={selected === card}
            onClick={() => onSelect(card)}
            className={cn(
              "flex h-16 w-12 cursor-pointer items-center justify-center rounded-lg border-2 text-sm font-bold transition-all duration-200 hover:-translate-y-2 active:scale-95 sm:h-20 sm:w-14 sm:text-base",
              selected === card
                ? "border-primary bg-primary text-primary-foreground shadow-lg shadow-primary/30"
                : "border-border bg-secondary text-foreground hover:border-primary/50",
            )}
          >
            {card}
          </button>
        ))}
      </div>
    </div>
  );
}
